import { createTheme } from "@mui/material/styles";

// Create a theme instance.
const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#1b444a",
    },
    secondary: {
      main: "#ED072A",
    },
    white: {
      main: "#FFFFFF",
    },
    highContrastLink: {
      main: "#0000FF",
      dark: "#00003D",
    },
    divider: "rgba(0,0,0,0.23)",
  },
  shape: {
    borderRadius: 2,
  },
  typography: {
    fontFamily: "Open Sans",
  },
  components: {
    // Override MUI TextField styling for disabled state
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root.Mui-disabled": {
            "& .MuiInputBase-input": {
              color: "#0080FF", // Bright blue color for disabled text
              "-webkit-text-fill-color": "#0080FF", // Override webkit autofill
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#0080FF", // Bright blue border for disabled state
            },
            "& .MuiInputLabel-root": {
              color: "#0080FF", // Bright blue label for disabled state
            },
          },
          "& .MuiInputLabel-root.Mui-disabled": {
            color: "#0080FF", // Bright blue label when disabled
          },
          "& .MuiFormHelperText-root.Mui-disabled": {
            color: "#0080FF", // Bright blue helper text when disabled
          },
        },
      },
    },
    // Also override for filled variant if used
    MuiFilledInput: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#0080FF",
            backgroundColor: "rgba(0, 128, 255, 0.1)", // Light blue background
            "& .MuiFilledInput-input": {
              color: "#0080FF",
              "-webkit-text-fill-color": "#0080FF",
            },
          },
        },
      },
    },
    // Override for standard variant if used
    MuiInput: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#0080FF",
            "&:before": {
              borderBottomColor: "#0080FF",
            },
            "& .MuiInput-input": {
              color: "#0080FF",
              "-webkit-text-fill-color": "#0080FF",
            },
          },
        },
      },
    },
  },
});

export default theme;
